import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { getToken, setToken as persistToken } from '../api/client';
import { login as loginApi, register as registerApi, getMe, updateMe } from '../api/authApi';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [establishment, setEstablishment] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = getToken();
    if (!token) {
      setLoading(false);
      return;
    }
    getMe()
      .then(setEstablishment)
      .catch(() => persistToken(null))
      .finally(() => setLoading(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const data = await loginApi({ email, password });
    persistToken(data.accessToken);
    setEstablishment(data.establishment);
    return data.establishment;
  }, []);

  const register = useCallback(async (payload) => {
    const data = await registerApi(payload);
    persistToken(data.accessToken);
    setEstablishment(data.establishment);
    return data.establishment;
  }, []);

  const logout = useCallback(() => {
    persistToken(null);
    setEstablishment(null);
  }, []);

  const updateEstablishment = useCallback(async (data) => {
    const updated = await updateMe(data);
    setEstablishment(updated);
    return updated;
  }, []);

  return (
    <AuthContext.Provider
      value={{ establishment, isAuthenticated: !!establishment, loading, login, register, logout, updateEstablishment }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within an AuthProvider');
  return ctx;
}
